<template>
  <br/>
  <p style="font-size: 30px;color: black;letter-spacing: 0.5vw;font-weight: bold;margin-bottom: 1vh">Company News</p>
  <p style="color: black">——</p>
  <div>
    <a-row v-for="(item, index) in news.items" :key="index" style="height: 22vh" @click="showmodal(index)">
      <a-row style="border-width: thin;border-top-style: solid; border-color: #cccccc">
      </a-row>
      <a-row >
        <div class="news_brief">
          <p style="color: black;font-weight: bold;font-size: 16px;margin-bottom: 0">{{ item.title }}</p>
          <p style="color: grey;text-align: left; max-height: 10vh;overflow-y: scroll;font-size: 14px">{{ item.summary }}</p>
        </div>
      </a-row>
      <br>
    </a-row>
  </div>
  <a-modal v-model:visible="modal.visible"
           :centered="true" :footer="null" :width="'100%'"
           :bodyStyle="{'padding-bottom': 0} " :destroyOnClose="true">
    <div class="news_detail">
      <p style="color: blue; font-size: 24px;margin-bottom: 2vh">{{ modal.title }}</p>
      <p style="color: blue;margin-bottom: 1vh;font-size: 20px">{{ modal.date }}</p>
      <p style="color: blue">——</p>
       <div style="height: 50vh;max-height: 50vh;margin-bottom:0;overflow-x: hidden;white-space: pre-line;font-size: 14px">
                <div v-html="modal.introduction">
                </div>
            </div>
    </div>
    <a-row style="padding-bottom: 4vh">
      <a-col :span="5"></a-col>
      <a-col :span="6">
        <LeftCircleTwoTone v-on:click="previous_news(modal.index)" :style="{fontSize: '4vh'} "/>
      </a-col>
      <a-col :span="6">
        <CloseCircleTwoTone v-on:click="close" :style="{fontSize: '4vh'}"/>
      </a-col>
      <a-col :span="6">
        <RightCircleTwoTone v-on:click="next_news(modal.index)" :style="{fontSize: '4vh'}"/>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import axios from 'axios'
import {reactive, onMounted} from 'vue'
import {LeftCircleTwoTone, RightCircleTwoTone, CloseCircleTwoTone} from "@ant-design/icons-vue/"

export default {
  name: 'News_page_en_m',
  components: {
    LeftCircleTwoTone, RightCircleTwoTone, CloseCircleTwoTone
  },
  setup() {
    const news = reactive({
      items: [],
    })
    const modal = reactive({
      title: '',
      date: '',
      summary: '',
      introduction: '',
      visible: false,
      index: 0,
    })
    const showmodal = (index) => {
      modal.visible = true
      modal.title = news.items[index].title
      modal.date = news.items[index].date
      modal.summary = news.items[index].summary
      modal.introduction = news.items[index].introduction
      modal.index = index
    }
    const previous_news = (index) => {
      if (index > 0) {
        close()
        showmodal(index - 1)
      }
    }
    const next_news = (index) => {
      if (index < news.items.length) {
        close()
        showmodal(index + 1)
      }
    }
    const close = () => {
      modal.visible = false
    }
    onMounted(() => {axios.get('https://sig-china.com:8081/api/news')
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
              news.items.push(res.data[i])
          }
          news.items.sort((a, b) => {
            return b['id'] - a['id']
          })
        })})
    return {news, modal, showmodal, close, previous_news, next_news}
  }
}
</script>
<style scoped>
.news_date_icon {
  height: 20vh;
  width: 20vh;
  background-image: url("../../../assets/image/news_icon.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 3vh calc((20.83vw - 20vh) / 2);
}

.news_date p {
  font-size: 4vh;
  margin-bottom: 1vh;
}

.news_date {
  padding-top: 2vh;
}

.news_brief {
  padding-top: 2vh;
  margin: 0 2vw;
  text-align: left;

}

.news_detail p {
  color: black;
}

.news_detail {
  margin: 0 5vw;
  padding-top: 6vh;
  height: 100%;
  padding-bottom: 6vh;
  text-align: left;
}
p {margin-bottom: 0}

</style>
